// DO NOT TYPE HERE
import './js/scroll-up';
import './js/bestsellers';
import './js/books-api';
import './js/categories-list';
import './js/category';
import './js/dark-mode';
import './js/footer';
import './js/team-items';
import './js/team-modal';
import './js/header';
import './js/modal-book-info';
import './js/support-ukraine';
